import React, { useState } from 'react';
import { Box, constants, Loading } from '@match/react-component-library';
import { useWindowSize } from 'modules/hooks';
import { DESKTOP_MIN } from 'modules/components/Router/Router';
import styled from 'packages/theming';

const { SPACE } = constants;
interface ContactUsPageProps {
  isMobi?: boolean;
}
const ContactUsSC10: React.FunctionComponent<ContactUsPageProps> = ({ isMobi }) => {
  const contactUsDetails = {
    ShowEmail: true,
    ShowPhone: false,
    EmailLink: 'https://help.stir.com/hc/en-us/requests/new'
  };

  const [showPhoneNumber, setShowPhoneNumber] = useState<boolean>(false);

  const [width] = useWindowSize();
  const pageWidth = width > DESKTOP_MIN ? '50%' : '100%';

  const phoneNumberClicked = () => {
    setShowPhoneNumber(true);
  };

  if (!contactUsDetails) {
    return <Loading />;
  }
  return (
    <Box width={pageWidth} paddingX={SPACE.MEDIUM}>
      <Box paddingX={isMobi ? SPACE.LARGE : undefined}>
        {contactUsDetails.ShowEmail && (
          <Box display="flex" paddingBottom={SPACE.SMEDIUM}>
            <StyledLink href={contactUsDetails.EmailLink}>Email us</StyledLink>
          </Box>
        )}
        {contactUsDetails.ShowPhone && (
          <Box display="flex" flexDirection="column">
            <StyledButton onClick={phoneNumberClicked}>Call us</StyledButton>
            {showPhoneNumber && (
              <Box margin={SPACE.MEDIUM}>
                You can call us between 8 am and 5 pm Central Time, Monday through Friday.
                1-888-628-9035
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

const StyledLink = styled('a')(({ theme }) => ({
  background: theme.palette.core1_100,
  borderRadius: theme.radii.round,
  color: theme.palette.light,
  padding: theme.space.medium,
  width: 160,
  textAlign: 'center',
  [':visited']: {
    color: theme.palette.light,
  },
  [':hover']: {
    textDecoration: 'none',
    background: theme.palette.core1_50,
  },
  fontSize: '16px',
}));

const StyledButton = styled('button')(({ theme }) => ({
  background: theme.palette.core1_100,
  borderRadius: theme.radii.round,
  color: theme.palette.light,
  padding: theme.space.medium,
  width: 160,
  textAlign: 'center',
  [':visited']: {
    color: theme.palette.light,
  },
  [':hover']: {
    textDecoration: 'none',
    background: theme.palette.core1_50,
  },
  border: 'none',
  fontSize: '16px',
}));

export default ContactUsSC10;
